import moment from "moment";

export const getDateSelector = (date) => moment(date, moment.ISO_8601, true).isValid() ? moment(date).format('x') : ""